import React, { useEffect, useRef, useState } from 'react';
import { IconButton } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { selectInputField } from 'src/theme/vemigoCustomStyles/VemigoCustomStyles';
import { style } from '@mui/system';

interface VemigoSelectFieldProps {
  placeholder?: string;
  options: string[];
  value: any;
  min: number;
  onChange: (selectedValue: string) => void;
}

const VemigoSelectField: React.FC<VemigoSelectFieldProps> = ({
  placeholder,
  options,
  value,
  min,
  onChange
}) => {
  const [open, setOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState('%');
  const [input, setInput] = useState('');

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [dropdownRef]);

  const handleButtonClick = () => {
    setOpen(!open);
  };

  const handleOnChange = (value) => {
    if (onChange && selectedValue !== '%') {
      if (selectedValue === '-₹' && (parseFloat(value) <= min || value.length === 0)) {
        setInput(value);
        onChange(selectedValue + ' ' + value);
      } else if (selectedValue === '+₹' ) {
        setInput(value);
        onChange(selectedValue + ' ' + value);
      }
    } else {
      if (!isNaN(value) && value < 100) {
        setInput(value);
        onChange(selectedValue + ' ' + value);
      }
    }
  };

  const handleMenuItemClick = (value: string) => {
    setSelectedValue(value);
    if (onChange) {
      // if (selectedValue[1] !== value[1]) {
      //   onChange('');
      //   setInput('');
      // } else if (selectedValue.length < 2 && selectedValue !== value) {
        onChange('');
        setInput('');
      // }
    }
    setOpen(false);
  };

  const handleClickAway = () => {
    setOpen(false);
  };

  return (
    <>
      <div
        style={{
          display: 'flex',
          background: 'white',
          boxShadow: '0 0 3px rgba(0, 0, 0, 0.6)',
          borderRadius: '9px'
        }}
      >
        <div style={{ position: 'relative' }}>
          {selectedValue !== '%' && (
            <IconButton
              style={{ fontSize: '15px', margin: '0 0 0 auto', padding: '9px' }}
              onClick={handleButtonClick}
            >
              {selectedValue}
            </IconButton>
          )}
          <input
            type="text"
            value={value}
            onChange={(e) => handleOnChange(e.target.value)}
            placeholder={placeholder || ''}
            style={selectInputField.input}
          />
        </div>
        {selectedValue === '%' && (
          <IconButton
            style={{ fontSize: '18px', margin: '0 0 0 auto', padding: '9px' }}
            onClick={handleButtonClick}
          >
            {selectedValue}
          </IconButton>
        )}
      </div>
      {open && (
        <div
          style={{
            padding: '2px',
            zIndex: 1,
            border: '1px solid #ccc',
            borderRadius: '4px',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            background: 'white'
          }}
        >
          {options.map((option, index) => (
            <div
              style={{ padding: '4px' }}
              key={index}
              onClick={() => handleMenuItemClick(option)}
            >
              {option}
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default VemigoSelectField;
